import React from "react";
import './Copyright.css'
export default function Copyright() {
    return (
        <div className="copyright ">
            <div className="container">
                <p>
                    Copyright © Aman Digital Services Website Designed and Developed By
                    <a href="https://amanindian.netlify.app/" title="Know About Aman Kumar" target="_blank" rel="noreferrer" > Er. Aman Kumar</a>
                </p>
            </div>
        </div >
    );
}
